import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const rejectVenueSync = async (eventId: string) => {
  const res = await fetch(`${API_URL}/venues/import/reject`, {
    method: 'POST',
    body: JSON.stringify({ event_id: eventId }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (res.status === Status.BAD_REQUEST || res.ok === false) {
    throw new Error('Something went wrong whilst rejecting the sync');
  }
};
